import Register from '@/modules/auth/components/Register.vue';
import Confirmation from '@/modules/auth/components/Confirmation.vue';
import Login from '@/modules/auth/containers/Login.vue';

export default [
    {
        path: '/register',
        name: 'Register',
        component: Register,
        meta: { requiresNavbar: false },
    }, {
        path: '/login',
        name: 'Login',
        component: Login,
        meta: { requiresNavbar: false },
    }, {
        path: '/confirm',
        name: 'Confirmation',
        component: Confirmation,
        meta: { requiresNavbar: false },
    }, {
        path: '/',
        name: 'Login',
        component: Login,
        meta: { requiresNavbar: false },
    },
];
